import { NgModule, Optional, SkipSelf, InjectionToken, inject } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { SfhSecurityService } from '@sasser/sfh-shared-security';
import { HttpErrorInterceptor } from '../shared/http-error.interceptor';
import { AuthGuard } from '../shared/auth.guard.service';
import { CanDeactivateGuard } from '../shared/can-deactivate-guard.service';
import { TokenInterceptor } from './authInterceptor.components';

// Define an injection token for the CoreModule loaded flag
export const CORE_MODULE_LOADED = new InjectionToken<boolean>('CORE_MODULE_LOADED');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    // Register the AuthInterceptor as a multi-provider for HTTP_INTERCEPTORS
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    
    AuthGuard,
    ErrorHandler,
    CanDeactivateGuard,
    SfhSecurityService,
    { provide: CORE_MODULE_LOADED, useValue: true } // Provide the token
  ]
})
export class CoreModule {
  constructor(
    //@Optional() @SkipSelf() parentModule?: CoreModule //@Inject(CORE_MODULE_LOADED) coreModuleLoaded: boolean | null
  ) {
    const coreModuleLoaded = inject(CORE_MODULE_LOADED, { optional: true, skipSelf: true });
    if (coreModuleLoaded) {
      throw new Error('CoreModule has already been loaded. Import CoreModule in the AppModule only.');
    }
  }
}